import { PackageDetails } from "../../../../../types";
import { Label } from "../../../../../components/shared";
import { DetailItem, StyledDetails } from "./styles";

const Details = ({
  realSize,
  count,
  palletSize,
  number,
  eanDrs = null,
}: PackageDetails) => {
  const items = [
    { label: "Wymiary rzeczywiste (cm)", value: realSize },
    { label: "Opakowanie zbiorcze:", value: count },
    { label: "Sztuk na palecie:", value: palletSize },
    { label: "Kod EAN:", value: number },
    { label: "Kod EAN DRS:", value: eanDrs },
  ];

  return (
    <StyledDetails>
      {items
        .filter((item) => item.value !== null && item.value !== "" && item.value !== "0")
        .map(({ label, value }) => (
          <DetailItem key={label}>
            {label} <Label>{value}</Label>
          </DetailItem>
        ))}
    </StyledDetails>
  );
};

export default Details;
